import { motion, AnimatePresence } from "framer-motion";
import CustomImage from "../CustomImage";
import { X } from "lucide-react";
//import VideoPlayer from "../VideoPlayer";

const PopupWrapper = ({ messages, typingIndicator }: any) => {
  console.log("messages inside popup wrapper", messages);

  const handlePopupClick = (cid: string) => {
    console.log("messages", messages);
    window.parent.postMessage(
      {
        type: "MAXIMISE_CHAT_WIDGET_OPEN",
        cid: messages.length > 0 ? messages[0].conversation : null,
      },
      "*"
    );
  };

  const closeMessages = () => {
    window.parent.postMessage(
      {
        type: "MAXIMISE_CHAT_WIDGET_ALERT_CLOSE",
      },
      "*"
    );
  };

  // Animation variants for messages
  const messageVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: "easeOut",
      },
    },
  };

  // Animation variants for typing indicator
  const typingVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeInOut",
      },
    },
  };

  return (
    <div className="flex h-full w-full items-end justify-end p-2">
      <div className="bg-transparent">
        <div className="flex justify-end px-3 pb-2">
          <div
            className="bg-gray-200 px-3 py-1 rounded-xl shadow-sm border cursor-pointer"
            onClick={() => closeMessages()}
          >
            <X className="size-3" />
          </div>
        </div>
        <div className="w-full flex justify-end items-end space-x-2 px-2">
          <div className="flex-shrink-0 mr-2">
            {(typingIndicator || messages.length > 0) && (
              <CustomImage
                src={
                  typingIndicator?.metadata?.avatar_url ||
                  messages[0]?.metadata?.avatar_url
                }
                alt={
                  typingIndicator?.metadata?.first_name ||
                  messages[0]?.metadata?.first_name
                }
                size={38}
              />
            )}
          </div>
          <div className="flex flex-col space-y-3 min-w-48 ">
            {/* {
              <motion.div
                className="bg-background rounded-xl text-sm shadow-sm w-full cursor-pointer"
                initial="hidden"
                animate="visible"
                variants={messageVariants}
              >
                <VideoPlayer src="https://maximise.nyc3.cdn.digitaloceanspaces.com/sample.mp4" />
              </motion.div>
            } */}
            {messages.map((message: any, idx: number) => (
              <motion.div
                key={idx}
                className="bg-gray-50 rounded-xl text-sm p-4 shadow-sm border border-gray-200 w-full cursor-pointer space-y-3"
                initial="hidden"
                animate="visible"
                variants={messageVariants}
                onClick={() => handlePopupClick("")}
              >
                {idx === 0 && (
                  <div>
                    <span className="text-xs font-medium text-gray-500">
                      {messages[0].metadata?.first_name}
                      {messages[0].metadata?.company &&
                        ` from ` + messages[0].metadata.company}
                    </span>
                  </div>
                )}
                <p className="line-clamp-3 text-ellipsis">{message?.content}</p>
              </motion.div>
            ))}
            <AnimatePresence>
              {typingIndicator && (
                <motion.div
                  className="flex justify-start"
                  initial="hidden"
                  animate="visible"
                  exit="hidden"
                  variants={typingVariants}
                >
                  <div className="relative flex items-center">
                    <div className="bg-gray-50 rounded-xl text-sm p-4 shadow-sm border border-gray-200 w-full cursor-pointer flex items-center space-x-2">
                      <div className="typing-indicator flex space-x-1">
                        <span className="dot animate-bounce"></span>
                        <span className="dot animate-bounce delay-100"></span>
                        <span className="dot animate-bounce delay-200"></span>
                      </div>
                    </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupWrapper;
